import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const teachingWorkloadApprovalAll: ApiFunc<`${typeof API.TEACHING_WORKLOAD_APPROVAL_ALL}`, 'get'> = data =>
  instance.get(API.TEACHING_WORKLOAD_APPROVAL_ALL, {
    params: data,
  })

export const teachingWorkloadApprovalByID: ApiFunc<
  `${typeof API.TEACHING_WORKLOAD_APPROVAL_BY_ID}{id}`,
  'get'
> = data =>
  instance.get(`${API.TEACHING_WORKLOAD_APPROVAL_BY_ID}${'id' in data ? prop('id', data) : data?.name}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const teachingWorkloadApprovalSubmit: ApiFunc<
  `${typeof API.TEACHING_WORKLOAD_APPROVAL_SUBMIT}`,
  'post'
> = data => instance.post(API.TEACHING_WORKLOAD_APPROVAL_SUBMIT, data)

export const teachingWorkloadApprovalResponse: ApiFunc<
  `${typeof API.TEACHING_WORKLOAD_APPROVAL_RESPONSE}`,
  'post'
> = data => instance.post(API.TEACHING_WORKLOAD_APPROVAL_RESPONSE, data)

export const teachingWorkloadReportBulk: ApiFunc<`${typeof API.TEACHING_WORKLOAD_REPORT_BULK}`, 'get'> = data =>
  instance.get(API.TEACHING_WORKLOAD_REPORT_BULK, {
    params: data,
    responseType: 'blob',
  })

export const teachingWorkloadReportSingle: ApiFunc<`${typeof API.TEACHING_WORKLOAD_REPORT_SINGLE}`, 'get'> = data =>
  instance.get(API.TEACHING_WORKLOAD_REPORT_SINGLE, {
    params: data,
    responseType: 'blob',
  })
